import { ErrorHandler, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { PagerBaseComponent } from '~/app/open-age/core/structures';
import { Designation } from '../models';
import { DesignationService } from '../services';

export class DesignationListBaseComponent extends PagerBaseComponent<Designation> implements OnInit, OnDestroy, OnChanges {

    @Input()
    readonly = false;

    @Input()
    status: string;

    @Input()
    name: string;

    @Input()
    sort = 'code';

    constructor(
        api: DesignationService,
        errorHandler: ErrorHandler
    ) {
        super({
            api,
            errorHandler,
            pageOptions: { limit: 10 },
            filters: ['name', 'status'],
        });
    }

    ngOnInit() {
        this.fetch();
    }

    ngOnChanges(): void {
        // this.filters.set('status', this.status);
        this.filters.set('name', this.name);
        this.fetch();

    }

    ngOnDestroy(): void { }
}
